import { Link } from "react-router-dom";
import SafeLifeLogo from "./SafeLifeLogo";
import { COMPANY, insuranceTypes } from "../data/insurances";

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-white pt-20 pb-10 mt-20" data-testid="site-footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-14">
          {/* Brand */}
          <div className="space-y-4">
            <div className="bg-white rounded-xl p-3 inline-block">
              <SafeLifeLogo className="h-12" />
            </div>
            <p className="text-white/70 font-serif-accent text-lg italic leading-snug">
              "Proteger a vida é algo pessoal."
            </p>
            <div className="flex gap-3 pt-2">
              <a
                href="#"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-lego flex items-center justify-center transition-colors"
                data-testid="footer-social-instagram"
              >
                <i className="fa-brands fa-instagram" />
              </a>
              <a
                href="#"
                aria-label="LinkedIn"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-lego flex items-center justify-center transition-colors"
                data-testid="footer-social-linkedin"
              >
                <i className="fa-brands fa-linkedin-in" />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-lego flex items-center justify-center transition-colors"
                data-testid="footer-social-facebook"
              >
                <i className="fa-brands fa-facebook-f" />
              </a>
              <a
                href={`https://wa.me/55${COMPANY.whatsapp}`}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-lego flex items-center justify-center transition-colors"
                data-testid="footer-social-whatsapp"
              >
                <i className="fa-brands fa-whatsapp" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading font-bold mb-5 text-lg">Seguros</h4>
            <ul className="space-y-2 text-white/70">
              {insuranceTypes.slice(0, 6).map((i) => (
                <li key={i.slug}>
                  <Link
                    to={`/seguros/${i.slug}`}
                    className="hover:text-white transition-colors text-sm"
                    data-testid={`footer-seguro-${i.slug}`}
                  >
                    {i.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/cotacao" className="text-lego font-semibold text-sm hover:text-white">
                  Cotar agora →
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-bold mb-5 text-lg">Safe Life</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><Link to="/sobre" className="hover:text-white">Sobre nós</Link></li>
              <li><Link to="/contato" className="hover:text-white">Contato</Link></li>
              <li><Link to="/politica-privacidade" className="hover:text-white">Política de Privacidade</Link></li>
              <li><Link to="/termos-uso" className="hover:text-white">Termos de Uso</Link></li>
              <li><Link to="/cookies" className="hover:text-white">Política de Cookies</Link></li>
              <li><Link to="/admin/login" className="hover:text-white opacity-60">Área interna</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold mb-5 text-lg">Fale com a gente</h4>
            <ul className="space-y-3 text-white/70 text-sm">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-lego mt-1" />
                <span>{COMPANY.address}<br />CEP {COMPANY.zipCode}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-brands fa-whatsapp text-lego mt-1" />
                <a href={`https://wa.me/55${COMPANY.whatsapp}`} target="_blank" rel="noreferrer" className="hover:text-white">
                  {COMPANY.whatsappDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-envelope text-lego mt-1" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-white/50">
          <div>
            <p>
              <strong className="text-white/80">{COMPANY.name}</strong> — CNPJ: {COMPANY.cnpj} — SUSEP: {COMPANY.susep}
            </p>
            <p className="mt-1">
              A Safe Life é uma corretora devidamente registrada. As coberturas apresentadas seguem as condições gerais de cada seguradora parceira e estão sujeitas à aceitação e análise.
            </p>
          </div>
          <p className="md:text-right">
            © {new Date().getFullYear()} Safe Life. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
